export default {
  DEFAULT: {
    TITLE: `Configuration par défaut`,
    SUMMARY: `Les configurations suivantes vont être automatiquement sélectionnées lorsqu'un paramétrage est nécessaire.`
  },
  DEFAULTFILTERMAINSCHEDULE: {
    LABEL: `Quart de travail (filtre)`,
    DESCRIPTION: `Permet de filtrer les utilisateurs éligibles pour un quart de travail (création et modification).`
  },
  DEFAULTFILTEREMPLOYEELISTWARNINGS: {
    LABEL: `Liste d'utilisateur`,
    DESCRIPTION: `Permet d'afficher des avertissements dans la liste d'utilisateurs (ex: contrat expiré, ne possède pas de contrat, etc).`
  },
  DEFAULTCONFIGCONTACTLISTS: {
    LABEL: `Liste de contact`,
    DESCRIPTION: `Permet de paramétrer la configuration par défaut des listes de contacts.`
  },
  DEFAULTFILTERQUICKADD: {
    LABEL: `Ajout rapide`,
    DESCRIPTION: `Permet de paramétrer la configuration par défaut des ajouts rapides dans les modèles d'horaire.`
  },
  DEFAULTSORTMAINSCHEDULE: {
    LABEL: `Quart de travail (classement)`,
    DESCRIPTION: `Permet de suggérer des utilisateurs pour un quart de travail selon ce classement.`
  },
  DEFAULTFILTERAUTOSCHEDULE: {
    LABEL: `Horaire automatique`,
    DESCRIPTION: `Permet de déterminer l'éligibilité des utilisateurs pour l'assignation automatique à des quarts de travail.`
  },
  SHIFTS: `Quarts de travail :`,
  OTHERS: `Autres :`,
  PROCEDURES: `Procédures`,
  PROCEDURE_DESCRIPTION: `Les procédures seront utilisées dans l'ordre où elles apparaissent ici.`,
  PROCEDURE_REQUIRED: `Le champ des procédures est requis et doit en contenir au moins une.`,
  USER_FILTER: `Filtre`,
  USER_SORT: `Classement`,
  LIST: {
    TITLE: `Configurations de listes de contacts`,
    SUMMARY: `Permet de créer des listes avec plusieurs procédures, comme des listes contenant des procédures de temps régulier et de temps supplémentaire.`,
    DELETE_BUTTON: {
      TITLE: `Supprimer la configuration`,
      SUMMARY: `Voulez-vous vraiment supprimer cette configuration?`,
      PRIMARY_ACTION: `Supprimer`
    }
  },
  PROCEDURE: {
    TITLE: `Procédures`,
    SUMMARY: `Une procédure est la combinaison d'un filtre et d'un classement. Ceci facilite la réutilisation de leurs actions à travers différentes listes de contacts.`,
    DELETE_BUTTON: {
      TITLE: `Supprimer la procédure`,
      SUMMARY: `Voulez-vous vraiment supprimer cette procédure?`,
      PRIMARY_ACTION: `Supprimer`
    },
    DEPENDENCIES: `<0>Avertissement: </0>Vous ne pouvez pas supprimer cette procédure car certaines configurations de listes de contacts l'utilisent:<1></1> 
    Veuillez d'abord modifier ces configurations de listes de contacts.`
  },
  SORT: {
    TITLE: `Classements`,
    SUMMARY: `Les classements sont des algorithmes permettant de trier les employés selon leurs caractéristiques ou leur expérience.`,
    DELETE_BUTTON: {
      TITLE: `Supprimer le classement`,
      SUMMARY: `Voulez-vous vraiment supprimer ce classement?`,
      PRIMARY_ACTION: `Supprimer`
    },
    DEPENDENCIES: `<0>Avertissement: </0>Vous ne pouvez pas supprimer ce classement car certaines procédures l'utilisent:<1></1> 
    Veuillez d'abord modifier ces procédures.`
  },
  FILTER: {
    TITLE: `Filtres`,
    SUMMARY: `Les filtres sont une collection de règles et de critères permettant de retirer certains employés des listes de contacts concernées.`,
    DELETE_BUTTON: {
      TITLE: `Supprimer le filtre`,
      SUMMARY: `Voulez-vous vraiment supprimer ce filtre?`,
      PRIMARY_ACTION: `Supprimer`
    },
    DEPENDENCIES: `<0>Avertissement: </0>Vous ne pouvez pas supprimer ce filtre car certaines procédures l'utilisent:<1></1> 
    Veuillez d'abord modifier ces procédures avant de suppriemr ce filtre.`
  },
  CREATE_CONFIG: `Créer une configuration`,
  CREATE_FILTER: `Créer un filtre`,
  CREATE_SORT: `Créer un classement`,
  CREATE_PROCEDURE: `Créer une procédure`,
  CONCURRENT_CALLS_RATIO: `Ratio maximal d'appels simultanés`,
  DELETE_BUTTON: {
    TITLE: `Voulez-vous vraiment supprimer ceci?`,
    SUMMARY: ``,
    PRIMARY_ACTION: `Supprimer`
  },
  NAME_REQUIRED: `Le nom est requis`,
  DESCRIPTION_REQUIRED: `La description est requise.`,
  procedure: {
    CREATE: {
      TITLE: `Créer une procédure`,
      SUMMARY: `Une procédure est la combinaison d'un filtre et d'un classement. Ceci facilite la réutilisation de leurs actions à travers différentes listes de contacts.`
    },
    EDIT: {
      TITLE: `Modifier une procédure`,
      SUMMARY: `Une procédure est la combinaison d'un filtre et d'un classement. Ceci facilite la réutilisation de leurs actions à travers différentes listes de contacts.`
    },
    NAME: {
      LABEL: `Nom`,
      PLACEHOLDER: `Entrez le nom voulu`,
      DESCRIPTION: `Le nom doit décrire brièvement la liste ordonnée des utilisateurs éligibles. Le nom sera utilisé dans l'interface des listes de contact afin de contacter les utilisateurs et leur offrir des quarts de travail.`
    },
    DESCRIPTION: {
      LABEL: `Description`,
      PLACEHOLDER: `Entrez le description voulue`,
      DESCRIPTION: ``
    },
    USERFILTER: {
      LABEL: `Filtre`,
      DESCRIPTION: `Filtre à utiliser afin de déterminer l'éligibilité des utilisateurs.`
    },
    USERSORT: {
      LABEL: `Classement`,
      DESCRIPTION: `Classement à utiliser afin d'ordonner les utilisateurs éligibles.`
    },
    INCLUDEINSCHEDULE: {
      LABEL: `Inclure dans l'horaire`,
      DESCRIPTION: `Si cette case est cochée, la procédure sera disponible comme option pour trier et filtrer les utilisateurs dans l'horaire.`
    }
  },
  configuration: {
    CREATE: {
      TITLE: `Créer une configuration`,
      SUMMARY: `Permet de créer des listes avec plusieurs procédures, comme des listes contenant des procédures de temps régulier et de temps supplémentaire.`
    },
    EDIT: {
      TITLE: `Modifier une configuration`,
      SUMMARY: `Permet de créer des listes avec plusieurs procédures, comme des listes contenant des procédures de temps régulier et de temps supplémentaire.`
    },
    NAME: {
      LABEL: `Nom`,
      PLACEHOLDER: `Entrez le nom voulu`,
      DESCRIPTION: ``
    },
    DESCRIPTION: {
      LABEL: `Description`,
      PLACEHOLDER: `Entrez la description voulue`,
      DESCRIPTION: ``
    },
    CONCURRENTCALLSRATIO: {
      LABEL: `Ratio maximal d'appels simultanés`,
      PLACEHOLDER: `Entrez le ratio`,
      DESCRIPTION: `Permet d'utiliser ce ratio pour calculer le nombre d'utilisateurs pouvant être contactés en fonction du nombre de quarts de travail vacants (Doit être supérieur à 0). Si un ratio par défaut est déjà défini, il sera remplacé uniquement pour cette liste.`
    },
    PROCEDURE: {
      LABEL: `Procédure`,
      DESCRIPTION: ``
    },
    REMOVEIFINPREVIOUSLIST: {
      LABEL: `Empêcher l'éligibilité dans une liste précédente`,
      DESCRIPTION: `Empêche un utilisateur d'être éligible pour un quart de travail s'il lui est déjà offert dans une liste précédente.`
    },
    APPROVEDBYDEFAULT: {
      LABEL: `Approuver par défaut`,
      DESCRIPTION: `Cette liste sera approuvée par défaut lors de la création d'une liste de contact. La première liste sera toujours approuvée par defaut.`
    }
  },
  sorts: {
    CREATE: {
      TITLE: `Créer un ordonnancement`,
      SUMMARY: `Les classements sont des algorithmes permettant de trier les employés selon leurs caractéristiques ou leur expérience.`
    },
    EDIT: {
      TITLE: `Modifier un ordonnancement`,
      SUMMARY: `Les classements sont des algorithmes permettant de trier les employés selon leurs caractéristiques ou leur expérience.`
    },
    NAME: {
      LABEL: `Nom`,
      PLACEHOLDER: `Entrez le nom voulu`,
      DESCRIPTION: ``
    },
    DESCRIPTION: {
      LABEL: `Description`,
      PLACEHOLDER: `Entrez la description voulue`,
      DESCRIPTION: ``
    }
  },
  filters: {
    CREATE: {
      TITLE: `Créer un filtre`,
      SUMMARY: `Les filtres sont une collection de règles et de critères permettant de retirer certains employés des listes de contacts concernées.`
    },
    EDIT: {
      TITLE: `Modifier un filtre`,
      SUMMARY: `Les filtres sont une collection de règles et de critères permettant de retirer certains employés des listes de contacts concernées.`
    },
    NAME: {
      LABEL: `Nom`,
      PLACEHOLDER: `Entrez le nom voulu`,
      DESCRIPTION: ``
    },
    DESCRIPTION: {
      LABEL: `Description`,
      PLACEHOLDER: `Entrez la description voulue`,
      DESCRIPTION: ``
    },
    HOUR_RANGES: `Limite d'heure par période`,
    HOUR_RANGES_DESCRIPTION: `Vous pouvez avoir plusieurs limite d'heure qui s'entre-croise. Par exemple, 7 jours et 14 jours avec des règles différentes pour chacune.`,
    FLAG_OPTIONS: 'Options',
    HOUR_LIMITS: `Limite d'heure`,
    OPTIONS: {
      DISTANCEBETWEENSHIFTS: {
        LABEL: `Distance entre 2 quarts`,
        PLACEHOLDER: `Entrer le nombre de minutes requis entre 2 quarts de travail`,
        DESCRIPTION: `Le nombre entré va être utilisé afin de déterminer l'eligibilité d'un utilisateur pour un quart de travail en se basant sur ses quarts de travail entourant le nouveau quart.`
      },
      ALLOWEDHIRINGDATA: {
        LABEL: `Données d'embauche permises`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Seulement les employées possédant les données d'embauche selectionné vont être marqué comme éligible. Laisser vite pour que tout le monde soit éligible.`
      },
      MAXCONSECUTIVETIME: {
        LABEL: `Temps maximal consécutif de travail`,
        PLACEHOLDER: `Entrer le temps maximal en minutes`,
        DESCRIPTION: `Utiliser pour calculer l'eligibilité d'un employé si il possède plusieurs quart dans la même journée.`
      }
    },
    PERIODDURATION: {
      LABEL: `Durée de la période`,
      PLACEHOLDER: `Entrer le durée de la période en jour`,
      DESCRIPTION: ``
    },
    MAXHOURS: {
      LABEL: `Nombre maximal d'heure dans la période`,
      PLACEHOLDER: `Entrer le nombre d'heures `,
      DESCRIPTION: ``
    },
    BASEDATE: {
      LABEL: `Date de référence`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet de calculer le début des périodes.`
    }
  },
  ADD_SORT: `Ajouter`,
  REMOVE_SORT: `Retirer`,
  USED_SORTS: `Ordonnancements`,
  SORTS: `Ordonnancements`,
  SORTS_DESCRIPTION: `Les classements sont exécutés en ordre, le dernier aura donc plus d'impact que le premier.`,
  SORTS_REQUIRED: `Vous devez ajouter au moins un ordonnancement.`,
  FIELD_REQUIRED: `Ce champ est requis.`,
  sortFilterKey: {
    EVENTS: 'Quarts de travail',
    REQUESTS: 'Requêtes',
    HIRING_INFORMATIONS: "Données d'embauche",
    PROJECTS: 'Projets',
    OTHERS: 'Autres',
    FLAG_OPTIONS: 'Options',
    FILTER_NAME: 'Nom du filtre',
    FILTER_DESC: 'Description du filtre',
    CONFIGURE: 'Configurer',
    HOUR_LIMITS: "Limite d'heures",
    RANGE: 'Période',
    PERIOD_DURATION: 'Durée de la période',
    PERIOD_DURATION_PLACEHOLDER: 'Durée de la période en jours',
    MAX_NUMBER_OF_HOURS: "Nombre d'heures maximal",
    MAX_NUMBER_OF_HOURS_PLACEHOLDER: `Entrez le nombre d'heures`,
    PERIOD_START_DATE: 'Date du début de la période',
    PERIOD_START_DATE_PLACEHOLDER: 'Entrez une date de départ',
    ADD_HOUR_RANGE: 'Ajouter une nouvelle période de calcul',
    DISTANCE_BETWEEN_SHIFTS: 'Intervalle de temps minimal entre les quarts de travail',
    DISTANCE_BETWEEN_SHIFTS_PLACEHOLDER: 'Entrez la durée séparant les quarts de travail en minutes',
    ALLOWED_CONTRACT_TYPES: "Données d'embauche permises",
    ALLOWED_CONTRACT_TYPES_PLACEHOLDER: `Sélectionnez des contrats/permis/types d'employés`,
    ADD_FILTER: 'Ajoutez un filtre',
    DEFAULT_CONFIGURATION: 'Configuration par défaut',
    MAIN_SCHEDULE: "Filtre principal pour l'horaire",
    EMPLOYEE_LIST_WARNINGS: 'Filtre principal pour les avertissements donnés aux employés',
    MAIN_SCHEDULE_DESC: "Utilisez ce filtre afin de faciliter la création de quarts de travail dans l'horaire.",
    EMPLOYEE_LIST_WARNINGS_DESC: 'Utilisez ce filtre afin de souligner des employés dans la liste de gestion.',
    MAIN_SCHEDULE_SORT: "Classement principal pour l'horaire",
    MAIN_SCHEDULE_SORT_DESC: "Utilisez ce filtre afin de classer les employés dans l'horaire.",
    NO_FILTER: 'Aucun filtre',
    EMPLOYEE_NUMBER: "Numéro d'employé",
    EMPLOYEE_NUMBER_DESC: "Utilisez ce filtre afin de classer les utilisateurs selon leur numéro d'employé.",
    PRIORITY_NUMBER: 'Numéro de priorité',
    PRIORITY_NUMBER_DESC: 'Utilisez ce filtre afin de classer les utilisateurs selon leur numéro de priorité.',
    HIRING_DATE: "Date d'embauche",
    HIRING_DATE_DESC: "Utilisez ce filtre afin de classer les utilisateurs selon leur date d'embauche.",
    SENIORITY_DATE: "Date d'ancienneté",
    SENIORITY_DATE_DESC: "Utilisez ce filtre afin de classer les utilisateurs selon leur date d'ancienneté.",
    AVAILABILITY: 'Disponibilité',
    AVAILABILITY_DESC: 'Utilisez ce filtre afin de classer les utilisateurs selon leur nombre de disponibilités.',
    ATTENDANCE: 'Absence',
    ATTENDANCE_DESC: "Utilisez ce filtre afin de classer les utilisateurs selon leur nombre d'absences.",
    ATTRIBUTE_LEVELS: `Niveaux d'attributs`,
    ATTRIBUTE_LEVELS_DESC: 'Utilisez ce filtre afin de classer les utilisateurs selon leur niveau de qualification.',
    CONTRACT_TYPE: 'Type de contrat',
    CONTRACT_TYPE_DESC: 'Utilisez ce filtre afin de classer les utilisateurs selon un ordre défini par le type de contrat.',
    PERMIT_TYPES: 'Type de permis',
    PERMIT_TYPES_DESC: 'Utilisez ce filtre afin de classer les utilisateurs selon un ordre défini par le type de permis.',
    EMPLOYEE_TYPES: "Type d'employé",
    EMPLOYEE_TYPES_DESC: "Utilisez ce filtre afin de classer les utilisateurs selon un ordre défini par le type d'employé.",
    CONFIG_NAME: 'Nom de la configuration',
    CONFIG_DESC: 'Description de la configuration',
    PROCEDURE_NAME: 'Nom de la procédure',
    PROCEDURE_DESC: 'Description de la procédure',
    PROCEDURES_DESC:
      "Une procédure est la combinaison d'un filtre et d'un classement. Ceci facilite la réutilisation de leurs actions à travers différentes listes de contacts.",
    ADD_PROCEDURE: 'Ajouter une procédure',
    SHIFT_SWAP_AND_OFFER: 'Filtre principal pour les échanges de quarts de travail',
    SORT_NAME: 'Nom du classement',
    SORT_DESC: 'Description du classement',
    ADD_SORT: 'Ajouter une méthode de classement',
    NO_SORT: 'Aucun classement',
    PROCEDURE_DELETE_CONFIRMATION: 'Êtes-vous certain(e) de vouloir supprimer cette procédure?',
    SORT_DELETE_CONFIRMATION: 'Êtes-vous certain(e) de vouloir supprimer ce classement?',
    FILTER_DELETE_CONFIRMATION: 'Êtes-vous certain(e) de vouloir supprimer ce filtre?',
    CONTACT_CONFIG_DELETE_CONFIRMATION: 'Êtes-vous certain(e) de vouloir supprimer cette configuration?',
    SORT_SAVED: 'Classement enregistré',
    FILTER_SAVED: 'Filtre enregistré',
    PROCEDURE_SAVED: 'Procédure enregistrée',
    CONTACT_CONFIG_SAVED: 'Configuration enregistrée',
    SORT_UPDATED: 'Classement mis à jour',
    FILTER_UPDATED: 'Filtre mis à jour',
    PROCEDURE_UPDATED: 'Procédure mise à jour',
    CONTACT_CONFIG_UPDATED: 'Configuration mise à jour',
    SORT_DELETED: 'Classement supprimé',
    FILTER_DELETED: 'Filtre supprimé',
    PROCEDURE_DELETED: 'Procédure supprimée',
    CONTACT_CONFIG_DELETED: 'Configuration supprimée',
    PROJECT_EXPERIENCE: 'Expérience par projet',
    PROJECT_EXPERIENCE_DESC: "Permet de paramétrer la liste d'utilisateurs selon leur expérience sur un projet.",
    CONTACT_LIST_DEFAULT_CONFIG: 'Configuration des listes de contacts',
    CONTACT_LIST_DEFAULT_CONFIG_DESC: 'Permet de paramétrer la configuration par défaut des listes de contacts.',
    QUICK_ADD_DEFAULT_FILTER: "Filtre par défaut pour l'ajout rapide (Quick add)",
    QUICK_ADD_DEFAULT_FILTER_DESC: "Permet de paramétrer la configuration par défaut des ajouts rapides dans les modèles d'horaire.",
    NO_PROCEDURE: 'Aucune procédure',
    NO_CONFIG: 'Aucune configuration',
    NUMBER_OF_HOURS_RANGE: "Nombre d'heures dans la période",
    NUMBER_OF_HOURS_RANGE_DESC: "Permet de classer en ordre croissant le nombre d'heures dans la période.",
    ADD_CONTACT_LIST_CONFIG: 'Ajouter une configuration de liste de contacts',
    CONTACT_LIST_CONFIG_DESC:
      'Permet de créer des listes avec plusieurs procédures, comme des listes contenant des procédures de temps régulier et de temps supplémentaire.',
    REMOVE_USERS_FROM_PREVIOUS_LIST: "Empêcher l'éligibilité dans une liste précédente",
    REMOVE_USERS_FROM_PREVIOUS_LIST_DESC: "Empêche un utilisateur d'être éligible pour un quart de travail s'il lui est offert dans une liste précédente.",
    IS_WORKING_SORT: 'Travaille déjà',
    IS_WORKING_SORT_DESC: 'Permet de classer en fonction du nombre de jours travaillés durant les dates sélectionnées.',
    DEPARTMENT: 'Départements',
    DEPARTMENT_DESC: "Permet de classer en fonction des départements de l'utilisateur et de la structure.",
    MAX_CONSECUTIVE_TIME: `Temps consécutif maximal travaillé`,
    MAX_CONSECUTIVE_TIME_PLACEHOLDER: `Entrez le temps consécutif maximal en minutes`,
    CROWS_FLIGHT_DISTANCE_SORT: 'Distance',
    CROWS_FLIGHT_DISTANCE_SORT_DESC:
      "Permet de classer en fonction de la distance (à vol d'oiseau) entre l'adresse de l'utilisateur et l'adresse de son emplacement de travail.",
    BACK_TO_CONTACT_LIST_CONFIG_MGMT: 'Retourner à la page de gestion',
    BACK_TO_PROCEDURES_MGMT: 'Retourner à la liste des procédures',
    BACK_TO_SORTS_MGMT: 'Retourner à la liste des classements',
    BACK_TO_FILTERS_MGMT: 'Retourner à la liste des filtres',
    NUMBER_OF_TIMES_CONTACTED_SORT: 'Nombre de contacts effectués',
    NUMBER_OF_TIMES_CONTACTED_SORT_DESC: `Permet de classer en fonction du nombre de fois où l'utilisateur a été contacté.`,
    LAST_ACCEPTED_SORT: 'Dernier accepté',
    LAST_ACCEPTED_SORT_DESC: 'Permet de classer en fonction du dernier utilisateur, en ordre de priorité, ayant accepté un quart de travail.',
    LAST_ACCEPTED_BY_POSITION_SORT: 'Dernier accepté par position',
    LAST_ACCEPTED_BY_POSITION_SORT_DESC:
      'Permet de classer en fonction du dernier utilisateur, en ordre de priorité, ayant accepté un quart de travail dans une liste sur la même position.',
    MAIN_AUTO_SCHEDULE_FILTER: "Filtre principal pour la génération d'horaire",
    MAIN_AUTO_SCHEDULE_FILTER_DESC: 'Permet de déterminer quel utilisateur est éligible à quel quart de travail.',
    NUMBER_OF_HOURS_OFFERED_SORT: 'Heures supplémentaires',
    NUMBER_OF_HOURS_OFFERED_SORT_DESC: `Permet de classer en fonction du nombre d'heures qu'un utilisateur a accepté ou lui ayant été proposées dans une liste de contacts.`,
    OVERWRITE_NUMBER_OF_HOURS_OFFERED_LABEL: `Remplacer le nombre d'heures offertes`,
    OVERWRITE_NUMBER_OF_HOURS_OFFERED_DESC: `Permet de faire correspondre le nombre d'heures offertes à la durée du poste accepté lorsqu'un utilisateur accepte un poste.`,
    CLIENT_SENIORITY_SORT: 'Ancienneté par client',
    CLIENT_SENIORITY_SORT_DESC: `Utilise l'ancienneté la plus grande pour le client assigné de l'utilisateur.`,
    POSITION_SENIORITY_SORT: 'Ancienneté par position',
    POSITION_SENIORITY_SORT_DESC: `Utilise l'ancienneté la plus grande pour la position assigné de l'utilisateur.`,
    INCLUDE_ASSOCIATED_PROJECTS: `Inclure l'expérience sur des projets associés`,
    CONCURRENT_CALLS_RATIO: `Ratio maximal d'appels simultanés`,
    CONCURRENT_CALLS_RATIO_DESC: `Permet d'utiliser ce ratio pour calculer le nombre d'utilisateurs pouvant être contactés en fonction du nombre de quarts de travail vacants (Doit être supérieur à 0).`,
    CONCURRENT_CALLS_RATIO_NOTE: `Si un ratio par défaut est déjà défini, il sera remplacé uniquement pour cette liste`,
    PREFERRED_ATTRIBUTES_SORT: `Attributs préférés`,
    PREFERRED_ATTRIBUTES_SORT_DESC: `Permet de classer en fonction des utilisateurs ayant des attributs préférés.`,
    OCCUPATIONS_SORT: `Occupations`,
    OCCUPATIONS_SORT_DESC: `Permet de classer en fonction des occupations des utilisateurs, primaires en premier, puis secondaires, puis les autres après.`,
    MISSING_NAME: `Veuillez entrer un nom`,
    INCLUDEASSOCIATEDPROJ: {
      LABEL: `Inclure l'expérience associée au projet`
    }
  },
  sortOrder: {
    OPTIONS: { asc: 'Ascendant', desc: 'Descendant' }
  },
  flags: {
    EVENT_STARTS_DURING: 'Évènement débutant durant la période',
    EVENT_STARTS_DURING_DESC: "Si l'utilisateur participe à un évènement débutant durant la période à valider, il sera filtré.",
    EVENT_ENDS_DURING: 'Évènement finissant durant la période',
    EVENT_ENDS_DURING_DESC: "Si l'utilisateur participe à un évènement finissant durant la période à valider, il sera filtré.",
    EVENT_OVERLAPPING: 'Évènement chevauchant la période',
    EVENT_OVERLAPPING_DESC: "Si l'utilisateur participe à un évènement chevauchant la période à valider, il sera filtré.",
    EVENT_DISTANCE: 'Intervalle de temps entre les périodes',
    EVENT_DISTANCE_DESC: "Si l'utilisateur participe à un évènement trop proche de la période à valider, il sera filtré.",
    UNAVAILABLE_OVERLAP: 'Indisponible durant la période',
    UNAVAILABLE_OVERLAP_DESC: "Si l'utilisateur n'est pas disponible durant la période à valider, il sera filtré.",
    NO_CURRENT_AVAILABILITY: 'Aucune disponibilité à jour',
    NO_CURRENT_AVAILABILITY_DESC: "Si l'utilisateur n'a pas de disponibilité à jour pour la période à valider, il sera filtré",
    PENDING_AVAILABILITY: "Demande de disponibilité en attente d'approbation",
    PENDING_AVAILABILITY_DESC: "Si l'utilisateur a une demande de disponibilité en attente, il sera indiqué, mais pas filtré.",
    UNAVAILABLE_ALL_DAY: 'Indisponible',
    UNAVAILABLE_ALL_DAY_DESC: "Filtera l'utilisateur si il est indisponible toute la journée et non juste sur une plage dans la journée.",
    TIME_OFF_OVERLAPPING: 'Congé chevauchant la période',
    TIME_OFF_OVERLAPPING_DESC: "Si l'utilisateur est en congé dans la période à valider, il sera filtré.",
    TIME_OFF_DURING_WEEK: 'Congé durant la semaine',
    TIME_OFF_DURING_WEEK_DESC: "Si l'utilisateur est en congé durant la semaine à valider, il sera filtré.",
    LEAVE_OVERLAPPING: 'Absence chevauchant la période',
    LEAVE_OVERLAPPING_DESC: "Si l'utilisateur est absent durant la période à valider, il sera filtré.",
    EMPLOYEE_TYPE: "Type d'employé",
    EMPLOYEE_TYPE_DESC: "Si l'utilisateur n'est pas qualifié comme étant du bon type d'employé, il sera filtré.",
    EMPLOYEE_STATUS: "Statut d'employé",
    EMPLOYEE_STATUS_DESC: "Si l'utilisateur n'est pas actif, il sera filtré.",
    HAS_RESTRICTIONS: 'A des restrictions',
    HAS_RESTRICTIONS_DESC: "Si l'utilisateur a une ou plusieurs restrictions, il sera filtré.",
    MISSING_SKILLS: 'Qualifications manquantes',
    MISSING_SKILLS_DESC: "Si l'utilisateur ne possède pas les qualifications requises durant la période à valider, il sera filtré.",
    MISSING_REQUIREMENTS: 'Exigences manquantes',
    MISSING_REQUIREMENTS_DESC: "Si l'utilisateur ne possède pas les exigences requises durant la période à valider, il sera filtré.",
    EXPIRED_CONTRACT: 'Contrat expiré',
    EXPIRED_CONTRACT_DESC: "Si l'utilisateur voit son contrat expirer durant la période à valider, il sera filtré.",
    EXPIRED_PERMIT: 'Permis expiré',
    EXPIRED_PERMIT_DESC: "Si l'utilisateur voit son permis expirer durant la période à valider, il sera filtré.",
    EXPIRED_EMPLOYEE_TYPE: "Type d'employé expiré",
    EXPIRED_EMPLOYEE_TYPE_DESC: "Si l'utilisateur voit son type d'employé expirer durant la période à valider, il sera filtré.",
    NO_CONTRACT: 'Aucun contrat',
    NO_CONTRACT_DESC: "Si l'utilisateur n'a pas de contrat, il sera filtré.",
    NO_PERMIT: 'Aucun permis',
    NO_PERMIT_DESC: "Si l'utilisateur n'a pas de permis, il sera filtré.",
    NO_EMPLOYEE_TYPE: "Aucun type d'employé",
    NO_EMPLOYEE_TYPE_DESC: "Si l'utilisateur n'a pas de type d'employé, il sera filtré.",
    MAX_NUMBER_OF_HOURS: "Nombre d'heures maximal",
    MAX_NUMBER_OF_HOURS_DESC: "Si l'utilisateur a dépassé le nombre d'heures que ce qu'autorise son type d'employé/contrat/permis, il sera filtré.",
    MAX_NUMBER_OF_HOURS_PER_DAY: "Nombre maximum d'heures attribuées par période de 24 heures",
    MAX_NUMBER_OF_HOURS_PER_DAY_DESC:
      "Si l'utilisateur a plus d'heures que permis dans une journée, il sera filtré. (Prend en compte l'heure de début des quarts de travail)",
    MAX_NUMBER_OF_HOURS_PER_DAY_START_TIME: "Heure de début d'une journée de travail à prendre en compte lors du filtrage",
    MAX_NUMBER_OF_HOURS_PER_DAY_START_TIME_DESC: ' ',
    NUMBER_OF_HOURS_MAX_PER_DAY: 'Durée maximale d’une journée de travail (en minutes)',
    NUMBER_OF_HOURS_MAX_PER_DAY_DESC: 'Min: {{ min }}, Max: {{ max }}',
    MAX_CONSECUTIVE_DAYS: `Nombre de jours de suite maximum`,
    MAX_CONSECUTIVE_DAYS_DESC: `Filtre les utilisateurs travaillant plus d'un certain nombre de jours de suite`,
    NUMBER_OF_MAX_CONSECUTIVE_DAYS: `Nombre de jours de suite maximum`,
    NUMBER_OF_MAX_CONSECUTIVE_DAYS_DESC: `Min: {{ min }}, Max: {{ max }}`,
    RIGHT_DEPARTMENT: 'Bon département',
    RIGHT_DEPARTMENT_DESC: "Si l'utilisateur n'est pas affecté au bon département, il sera filtré.",
    RIGHT_TEAM: 'Bonne équipe',
    RIGHT_TEAM_DESC: `Si l'utilisateur n'est pas affecté à la bonne équipe, il sera filtré.`,
    RIGHT_PROJECT: 'Bon projet',
    RIGHT_PROJECT_DESC: `Si l'utilisateur n'est pas affecté au bon projet, il sera filtré.`,
    INACTIF_USER: 'Utilisateur inactif',
    INACTIF_USER_DESC: "Si l'utilisateur est inactif, il sera filtré.",
    ARCHIVED_USER: 'Utilisateur archivé ',
    ARCHIVED_USER_DESC: "Si l'utilisateur est archivé, il sera filtré.",
    CHECK_START_AND_END: "Hors période d'emploi",
    CHECK_START_AND_END_DESC:
      "Si l'utilisateur est assigné à un quart de travail ayant lieu avant sa date d'entrée en fonction ou après sa date de cessation de travail, il sera filtré.",
    TERMINATED_USER: 'Utilisateur résilié',
    TERMINATED_USER_DESC: "Si l'utilisateur a été résilié, il sera filtré.",
    PROJECT_LOCK: 'Utilisateur verrouillé sur un projet',
    PROJECT_LOCK_DESC: "Si l'utilisateur est verrouillé sur un projet, il sera filtré.",
    IN_REST_TIME: 'En temps de repos',
    IN_REST_TIME_DESC: "Si l'utilisateur a un quart de travail avec un temps de repos en cours, il sera filtré.",
    MISSING_REGION: 'Étiquette de région manquante',
    MISSING_REGION_DESC: "Si l'utilisateur est assigné à un quart de travail alors qu'il n'a pas l'étiquette de région requise, il sera filtré.",
    ADJACENT_SHIFTS: 'Quarts de travail adjacents',
    ADJACENT_SHIFTS_DESC:
      "Si l'utilisateur n'a pas de quart de travail débutant après ou terminant avant le quart de travail lui étant attribué, il sera filtré.",
    ADJACENT_BEFORE: 'Quarts de travail commençant avant',
    ADJACENT_BEFORE_DESC: "Si l'utilisateur n'a pas de quart de travail juste avant celui sélectionné, il sera filtré.",
    ADJACENT_AFTER: 'Quarts de travail commençant après',
    ADJACENT_AFTER_DESC: "Si l'utilisateur n'a pas de quart de travail juste après celui sélectionné, il sera filtré.",
    FILTER_BY_POSITION: 'Position',
    FILTER_BY_POSITION_DESC: "Si l'utilisateur ne possède pas la bonne position, il sera filtré.",
    MAX_CONSECUTIVE_TIME: `Maximum de temps consécutif travaillé`,
    MAX_CONSECUTIVE_TIME_DESC:
      "Si l'utilisateur est assigné à plus d'un quart de travail consécutif et que la durée totale du temps de travail dépasse le nombre de minutes défini ci-dessous, il sera filtré. Les quarts de travail se chevauchant ne sont pas pris en compte.",
    OVERTIME_MAX_HOURS_PER_RANGE: `Heures supplémentaires`,
    OVERTIME_MAX_HOURS_PER_RANGE_DESC: `Les quarts de travail en heures supplémentaires ne seront pas inclus dans le calcul du nombre maximal d'heures travaillées dans une période.`,
    OVERTIME_MAX_HOURS_PER_DAY: `Heures supplémentaires`,
    OVERTIME_MAX_HOURS_PER_DAY_DESC: `Les quarts de travail en heures supplémentaires ne seront pas inclus dans le calcul du nombre maximal d'heures travaillées dans une journée.`,
    OVERTIME_EVENT_DISTANCE: `Heures supplémentaires`,
    OVERTIME_EVENT_DISTANCE_DESC: `Les quarts de travail en heures supplémentaires ne seront pas inclus dans le calcul de la distance entre les quarts de travail.`,
    OVERTIME_MAX_CONSECUTIVE_HOURS: `Heures supplémentaires`,
    OVERTIME_MAX_CONSECUTIVE_HOURS_DESC: `Les quarts de travail en heures supplémentaires ne seront pas inclus dans le calcul du nombre maximal d'heures travaillées consécutivement.`,
    PROJECT_LOCK_BY_DAY: 'Verrou de projet par jour',
    PROJECT_LOCK_BY_DAY_DESC:
      "Si l'utilisateur est assigné à un ou plusieurs projets à une certaine date, il déclenchera le message d'avertissement « Verrouillé sur projet ».",
    PROJECT_PREFER: 'Préféré sur un projet',
    PROJECT_PREFER_DESC: "Si l'utilisateur a défini des projets préférés, ils seront affichés lors d'une tentative d'affectation à un autre projet.",
    PROJECT_PREFER_BY_DAY: 'Préféré sur un projet par jour',
    PROJECT_PREFER_BY_DAY_DESC:
      "Si l'utilisateur a défini des projets préférés et que plusieurs d'entre eux sont planifiés à une certaine date, il déclenchera le message d'avertissement « Préféré sur projet ».",
    PROJECT_BLOCK: 'Bloqué du projet',
    PROJECT_BLOCK_DESC:
      "Si l'utilisateur est affecté à un projet sur lequel il est bloqué, il déclenchera un message d'avertissement lors de la tentative de planification.",
    RESTRICT_WORKABLE_HOURS: 'Restreindre les heures travaillables',
    RESTRICT_WORKABLE_HOURS_DESC: "L'utilisateur pourra seulement travailler selon la plage horaire définie dans son type d'employé/contrat/permis."
  }
}
